import React from 'react'
import OrderConfirmationHeader from '../orderConfirmation/OrderConfirmationHeader'
import OrderConfirmationContent, { OrderConfirmationSummary } from '../orderConfirmation/OrderConfirmationContent'
import { Order } from '../../types'

interface OrderSummaryProps {
  order: Order
  isRTL: boolean
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ order, isRTL }) => {
  return (
    <div className="w-full  bg-white rounded-tl-[50px] rounded-tr-[50px] flex flex-col justify-between items-center ">
      {/* Order Number Box */}
      {order?.id && (
        <div className="w-full flex justify-center items-center  ">
          <div className="h-[35px] w-[80px] bg-white rounded-bl-[10px] rounded-br-[10px] shadow-md flex items-center justify-center pt-3">
            <span className="text-sm font-medium font-['IBM_Plex_Sans_Arabic'] text-black">
              #{order.id}
            </span>
          </div>
        </div>
      )}

<div className="w-full px-4 pt-0 pb-4 flex flex-col justify-between">

{/* Header */}
<div className="w-full flex justify-start">
  <OrderConfirmationHeader order={order} isRTL={isRTL} />
</div>

{/* Items */}
<div className="w-full h-[200px] flex justify-center overflow-y-auto  ">
  <OrderConfirmationContent order={order} isRTL={isRTL} />
</div>



{/* Summary */}
<OrderConfirmationSummary order={order} isRTL={isRTL} />

</div>


      {/* Receipt Pattern */}
      <div className="w-full px-0 pt-15 bg-white flex justify-end items-center flex-shrink-0">
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="w-12 h-5 gap-3 bg-neutral-100 rounded-tl-[14px] rounded-tr-[14px]" />
        ))}
      </div>
    </div>
  )
}

export default OrderSummary

